import React from 'react';

const TestPage = () => {
  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
      <h1 style={{ color: '#333', fontSize: '2rem' }}>SlimBuddy Test Page</h1>
      <p style={{ color: '#666', fontSize: '1.2rem' }}>If you can see this, React is working!</p>
      <div style={{ backgroundColor: 'white', padding: '20px', marginTop: '20px', borderRadius: '10px' }}>
        <h2 style={{ color: '#667eea' }}>Components Test</h2>
        <p>This is a test to verify the app structure is working.</p>
      </div>
    </div>
  );
};

export default TestPage;